module.exports = __webpack_public_path__ + "media/img/scholarships/default_banner-e9fe924ca3922c25b07a8a18dc808661.svg";